// extracted by mini-css-extract-plugin
export default {"image-error":"styles_image-error__M3OYx","image":"styles_image__S17x6"};